/**
 * Вход в админку из браузера.
 * apps/web/src/pages/admin/AdminLogin.tsx
 *
 * Пароль уходит на сервер, обратно приходит защищённая кука на неделю. В браузере
 * ничего не хранится: ни пароля, ни ключа — только эта кука, недоступная для скриптов.
 */

import { useState } from 'react';
import './admin.css';

export default function AdminLogin({ onSuccess }: { onSuccess: () => void }) {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const r = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login, password }),
      });
      if (r.ok) {
        onSuccess();
        return;
      }
      const data = await r.json().catch(() => ({}));
      setError(data.error || 'Не получилось войти');
    } catch {
      setError('Сервер не отвечает');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-theme text-[#252A2D] min-h-screen bg-[#F7F7F4] flex items-center justify-center p-6">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-white rounded-2xl border border-[#E1E5E3] shadow-sm p-6"
      >
        <h1 className="text-xl font-bold text-[#252A2D]">Управление курсами</h1>
        <p className="text-sm text-[#626B73] mt-1">Введите пароль администратора.</p>

        <input
          aria-label="Логин"
          type="text"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          autoFocus
          autoComplete="username"
          className="mt-5 w-full border border-[#E1E5E3] rounded-xl px-4 py-3 focus:outline-none focus:border-[#0F766E]"
          placeholder="Логин"
        />

        <input
          aria-label="Пароль"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          className="mt-3 w-full border border-[#E1E5E3] rounded-xl px-4 py-3 focus:outline-none focus:border-[#0F766E]"
          placeholder="Пароль"
        />

        {error && <p className="mt-3 text-sm text-[#DC2626]">{error}</p>}

        <button
          type="submit"
          disabled={busy || !login || !password}
          className="mt-4 w-full bg-[#0F766E] text-white hover:bg-[#0B5F59] disabled:opacity-50 font-medium rounded-xl py-3 transition-colors"
        >
          {busy ? 'Проверяю…' : 'Войти'}
        </button>
      </form>
    </div>
  );
}
